import type { SVGProps } from 'react';

export function BitcoinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.953 9.246c.353-2.278-1.32-3.563-3.697-4.429a.51.51 0 0 1-.324-.605l.601-2.33a.5.5 0 0 0-.367-.61l-1.092-.264a.5.5 0 0 0-.601.362l-.577 2.235a.504.504 0 0 1-.602.363l-.67-.151a.5.5 0 0 1-.376-.614L13.822.99a.5.5 0 0 0-.367-.611L12.363.115a.5.5 0 0 0-.601.361l-.603 2.33a.5.5 0 0 1-.591.363 53 53 0 0 1-.842-.194.005.005 0 0 1-.004-.007.01.01 0 0 0-.004-.006l-2.364-.57a.5.5 0 0 0-.601.362l-.308 1.192c-.064.251-.027.48.226.537.393.088 1.827.507 2.01.866.088.172.114.357.11.527a.4.4 0 0 1-.015.096l-2.297 8.891c-.005.02-.008.03-.016.049-.158.36-1.663.29-2.044.193l-.036-.01a.44.44 0 0 0-.51.247l-.626 1.394a.5.5 0 0 0 .34.69l2.1.506q.496.121.981.245c.27.067.434.342.364.611l-.6 2.33a.5.5 0 0 0 .366.611l1.09.263a.5.5 0 0 0 .601-.361l.598-2.314a.503.503 0 0 1 .611-.36l.665.166a.5.5 0 0 1 .367.612l-.588 2.276a.5.5 0 0 0 .367.611l1.092.263a.5.5 0 0 0 .6-.361l.616-2.379a.51.51 0 0 1 .575-.37c3.291.535 5.757.169 6.823-2.77.897-2.474-.045-3.902-1.897-4.833 1.349-.3 2.364-1.157 2.635-2.926m-4.717 6.385c-.575 2.23-4.139 1.363-5.86.925a.507.507 0 0 1-.366-.616l.883-3.418a.51.51 0 0 1 .603-.37c1.731.376 5.343 1.145 4.74 3.479m.639-6.42c-.515 1.99-3.386 1.325-4.849.951a.507.507 0 0 1-.364-.617l.777-3.01a.51.51 0 0 1 .602-.37c1.473.314 4.372.96 3.834 3.045" />
    </svg>
  );
}
